<template>
    <div class="container">
        <banner-carsousel v-if="page.bannerList" :list="page.bannerList"></banner-carsousel>
        <data-market v-if="page.templatePageId === 3"></data-market>
        <news v-else-if="$route.path === '/news'"></news>
        <block-list v-else
            :list="blockList"
            :news-list="newsList"
            :resource-list="resourceList">
        </block-list>
    </div>
</template>

<script>
import { Page } from '@/models/page.js'
import { BlockEnum } from '@/config/enum'
import { News as NewsCenter } from "@/models/news.js"
import { ResourceManager } from '@/models/resource-manager'
import BannerCarsousel from '@/components/common/banner-carousel.vue'
import BlockList from '@/templates/content/block-list.vue'
import DataMarket from '@/templates/content/data-market.vue'
import News from '@/templates/content/news.vue'
export default {
    name: "Content",
    data(){
        return {
            page: {
                templatePageId: 0,
                bannerList: [],
                content: []
            },
            blockList: [],
            newsList: null,
            resourceList: null
        }
    },
    computed: {
        BlockEnum(){
            return BlockEnum
        }
    },
    components: {
        BannerCarsousel,
        BlockList,
        DataMarket,
        News
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            Page.getPageInfo(this.$route.path.slice(1)).then(res => {
                if(res){
                    this.page = res
                    this.blockList = this.page.content.filter(b => b.visible)
                    this._initNewsList()
                    this._initResourceList()
                }
            })
        },
        _initNewsList(){
            const isHasNews = this.blockList.some(block => block.type === this.BlockEnum.NEWS)
            if(isHasNews && !this.newsList){
                NewsCenter.getNewsListJson().then(res => {
                    this.newsList = res
                })
            }
        },
        _initResourceList(){
            const isHasResource = this.blockList.some(block => block.type === this.BlockEnum.RESOURCE)
            if(isHasResource && !this.resourceList){
                ResourceManager.getResourceListJson().then(res => {
                    this.resourceList = res
                })
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/content/index.vue